import { InjectionToken } from '@angular/core';

export const RECAPTCHA_ACTIONS = new InjectionToken<any>('RECAPTCHA_ACTIONS');
